"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerPlugin = void 0;
var router_1 = require("./router");
var builders_1 = require("./builders");
function routerPlugin(options) {
    if (options === void 0) { options = {}; }
    return {
        name: 'router',
        events: {
            afterPlugin: function () {
                var defaults = (0, router_1.getDefaultContext)();
                (0, router_1.setRouterContext)(__assign(__assign({}, defaults), options));
            },
            afterReduxStore: function () {
                router_1.router.mount();
            },
            legacyBuild: function (logic, input) {
                'urlToAction' in input && input.urlToAction && (0, builders_1.urlToAction)(input.urlToAction)(logic);
                'actionToUrl' in input && input.actionToUrl && (0, builders_1.actionToUrl)(input.actionToUrl)(logic);
                'beforeUnload' in input && input.beforeUnload && (0, builders_1.beforeUnload)(input.beforeUnload)(logic);
            },
        },
    };
}
exports.routerPlugin = routerPlugin;
//# sourceMappingURL=plugin.js.map